import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-chapter-questions',
  templateUrl: './chapter-questions.component.html',
  styleUrls: ['./chapter-questions.component.scss']
})
export class ChapterQuestionsComponent implements OnInit {
  chapterId: any = '';
  chapterDetails: any;
  chapterQuestions: any;
  chapterAnswers: any = [];

  currentQuestion = 0;
  constructor(
    private appService: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((res: any) => {
      this.chapterId = res.chapterId;
      this.appService.getChapter(this.chapterId).subscribe((res: any) => {
        this.chapterDetails = res;
      });
      this.appService.getChapterQuestions(this.chapterId).subscribe((res: any) => {
        this.chapterQuestions = res;
        this.loadSavedDrafts();
      });
      
      // get prefilled answers
      this.appService.getAnswerByUserByChapterId(this.chapterId).subscribe((res: any) => {
        this.chapterAnswers = res;
        this.chapterQuestions.forEach((question: any) => {
          const answer = this.chapterAnswers.find((ans: any) => ans.question_id === question.id);
          if (answer) {
            question.answer = answer.answer;
          }
        });
      });
    });
  }

  saveAnswers() {
    let answersData: any = [];
    let date = new Date();
    var dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
      .toISOString()
      .split("T")[0];
    for (let i = 0; i < this.chapterQuestions.length; i++) {
      let data: any = {
        "answer": this.chapterQuestions[i]['answer'],
        "user_id": sessionStorage.getItem('loginId'),
        "question_id": this.chapterQuestions[i]['id'],
        "status": "Active",
        "createdBy": sessionStorage.getItem('loginId'),
        "createdAt": dateString,
        "updatedBy": sessionStorage.getItem('loginId'),
        "updatedAt": dateString
      }
      if(data.answer == null || data.answer == undefined || data.answer == '') {
        this.toaster.error('Please answer all questions before submitting.', 'Error');
        return;
      }

      answersData.push(data);
    }

    this.appService.postAnswers({ "answers": answersData }).subscribe((res: any) => {
      this.markChapterComplete();
    });
  }

  markChapterComplete() {
    let date = new Date();
    var dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
      .toISOString()
      .split("T")[0];
    let data = {
      "user_id": sessionStorage.getItem('loginId'),
      "chapter_id": this.chapterId,
      "start_date": dateString,
      "end_date": dateString,
      "feedback": "Good Chapter",
      "status": "Completed"
    }

    // First check if this chapter is already completed for this user
    this.appService.userChapters().subscribe((chapters: any) => {
      const existingChapter = chapters.find(c => c.chapterId === this.chapterId);
      
      if (existingChapter && existingChapter.status === 'Completed') {
        // If chapter already exists and is completed, update it
        this.appService.userChapterUpdate(data, this.chapterId).subscribe((res: any) => {
          this.toaster.success('Chapter answers updated successfully!', 'Success');
          this.router.navigate(['/user-dashboard'], { state: { showCelebration: true, chapterId: this.chapterId } });
        });
      } else {
        // If chapter doesn't exist or isn't completed, create a new record
        this.appService.userChapter(data).subscribe((res: any) => {
          this.toaster.success('Chapter completed successfully!', 'Success');
          this.router.navigate(['/user-dashboard'], { state: { showCelebration: true, chapterId: this.chapterId } });
        });
      }
    });
  }

  navigateToNext() {
    if (this.chapterQuestions && this.currentQuestion < this.chapterQuestions.length - 1) {
      this.currentQuestion++;
    }
  }

  navigateToPrevious() {
    if (this.currentQuestion > 0) {
      this.currentQuestion--;
    }
  }

  goBackToDashboard() {
    this.router.navigate(['/user-dashboard']);
  }

  saveDraft(que: any) {
    const userId = sessionStorage.getItem('loginId');
    const draftKey = `draft_${userId}_${this.chapterId}`;
    
    const drafts = this.chapterQuestions.map((q: any) => ({
      questionId: q.id,
      answer: q.answer
    }));
    
    localStorage.setItem(draftKey, JSON.stringify(drafts));
    this.toaster.success('Draft saved successfully!', 'Success');
  }

  loadSavedDrafts() {
    const userId = sessionStorage.getItem('loginId');
    const draftKey = `draft_${userId}_${this.chapterId}`;
    
    const savedDrafts = localStorage.getItem(draftKey);
    if (savedDrafts) {
      const drafts = JSON.parse(savedDrafts);
      
      this.chapterQuestions = this.chapterQuestions.map((question: any) => {
        const savedDraft = drafts.find((d: any) => d.questionId === question.id);
        if (savedDraft) {
          question.answer = savedDraft.answer;
        }
        return question;
      });
    }
  }

}
